<template>
    <div class="tab-nav">
        <nav class="content-wap">
            <div class="content">
                <tab-bar></tab-bar>
                <search-box></search-box>
            </div>
        </nav>
    </div>
</template>

<script>
    export default {
        name: 'TabNav'
    }
</script>

<style lang="scss" scoped>
.tab-nav {
    margin-top: 15px;
    width: 100%;
    .content-wap {
        max-width: 1000px;
        margin: 0 auto;
        .content {
            width: 620px;
        }
    }
    // padding-top: 11px;
}
</style>